import React from 'react';

export const ColorfulDelete = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.229004" width="32" height="32" rx="16" fill="#FFEBE6" />
    <path
      d="M11.729 12.2501V20.5001C11.729 20.8979 11.887 21.2795 12.1683 21.5608C12.4496 21.8421 12.8312 22.0001 13.229 22.0001H19.229C19.6268 22.0001 20.0084 21.8421 20.2897 21.5608C20.571 21.2795 20.729 20.8979 20.729 20.5001V12.2501M13.979 12.2501C13.979 11.6534 14.2161 11.0811 14.638 10.6591C15.06 10.2372 15.6323 10.0001 16.229 10.0001V10.0001C16.8257 10.0001 17.398 10.2372 17.82 10.6591C18.242 11.0811 18.479 11.6534 18.479 12.2501V12.2501H13.979ZM13.979 12.2501H18.479H13.979ZM13.979 12.2501H11.729H13.979ZM18.479 12.2501H20.729H18.479ZM22.229 12.2501H20.729H22.229ZM10.229 12.2501H11.729H10.229Z"
      stroke="#BF2600"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
